import { createSlice } from "@reduxjs/toolkit";

const providingFieldsSlice = createSlice({
  name: "providingFields",
  initialState: [],
  reducers: {
    providingFieldsAdd(state, action) {
      return action.payload;
    },
  },
});

export const { providingFieldsAdd } = providingFieldsSlice.actions;
export default providingFieldsSlice.reducer;
